import { ReactNode, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './index';

interface LanguageProviderProps {
  children: ReactNode;
}

export function LanguageProvider({ children }: LanguageProviderProps) {
  // This hook can be used to perform locale-specific setup when the component mounts
  useEffect(() => {
    // For future implementation: additional locale setup
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}